module.exports = __webpack_public_path__ + "static/media/mobile-app-store.e19fcb20.svg";